import React from 'react';
import HeroSection from './hero/HeroSection';

const Home = () => <HeroSection />;

export default Home;
